const cols = [
  { title: "内容分区", links: ["主播塌房实锤", "网红翻车名单", "直播丑闻录屏", "人物档案专区", "实锤时间线"] },
  { title: "素材支持", links: ["录屏切片资料包", "聊天记录归档", "事件时间线图表", "逐条来源标注"] },
  { title: "更新机制", links: ["追更这期事件", "热度榜每 6 小时刷新", "投稿收录规则", "存疑标注说明"] },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200 mt-10 md:mt-14">
      <div className="max-w-[1400px] mx-auto px-3 md:px-6 py-10 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pb-8 border-b border-background-200">
          <div className="col-span-2 md:col-span-1">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 text-background-50">
                <i className="ri-flashlight-fill text-lg w-5 h-5 flex items-center justify-center"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">快手黑料</span>
            </a>
            <p className="text-[12px] text-foreground-500 leading-relaxed mt-3 max-w-[260px]">
              吃瓜前先看名单。聚焦主播塌房与网红翻车，按人物整理争议往事，聊天记录到视频证据逐条可核对。
            </p>
            <p className="flex items-center gap-1.5 text-[11px] text-foreground-400 mt-3">
              <i className="ri-refresh-line w-3.5 h-3.5 flex items-center justify-center"></i>名单持续更新中
            </p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-3">{c.title}</h4>
              <ul className="flex flex-col gap-2">
                {c.links.map((l) => (
                  <li key={l}>
                    <a href="#top" className="text-[13px] text-foreground-600 hover:text-primary-700 transition-colors">{l}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-6 flex flex-col gap-4">
          <p className="text-[11px] leading-relaxed text-foreground-500">
            内容声明：本站为娱乐盘点与素材整理的静态展示页，所呈现人物与事件用于演示吃瓜与检索逻辑，请理性看待、以公开可信的原始来源为准，勿据此对任何个人或账号作出人身定性。
          </p>
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
            <p className="text-[12px] text-foreground-500">快手黑料 · 吃瓜先看名单，实锤不落一环</p>
            <p className="flex items-center gap-2 text-[12px] text-foreground-400">
              <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center text-secondary-600"></i>
              素材均标注来源 · 存疑条目折叠待验
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}